import React from 'react';

export const MadeWithLove = () => (
  <p>
    Made with ❤️ &nbsp; by
    <br />
    Yellow Dog Software
  </p>
);
